import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/login',
    method: 'post',
    params: {
      'username':username,
      'password':password
    }
  })
}

export function getInfo() {
  return request({
    url: '/manage/user/getUserInfo',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js